import React, { Component } from 'react';

import {isNullOrEmpty} from '../Common/helpers';

import { API } from '../../ws/constants';

class PrintClient extends Component {
    constructor(props) {
        super(props);

        this.state = {
            clientId:this.props.props.match.params.id
            ,loggedIn:this.props.isLoggedIn
            ,clientData:null
            ,loginLevel:this.props.loginData.AccessLevel
            ,loading:false
            ,cId:""
            ,profilePic:""
            ,firstName:""
            ,lastName:""
            ,profession:""
            ,fullName:""
            ,gender:""
            ,dateOfBirth:""
            ,invoiceNumber:""
            ,idNumber:""
            ,financeNumber:""
            ,iban:""
            ,homePhone:""
            ,cellPhone:""
            ,homeAddress:""
            ,email:""
            ,notes:""
            ,isActive:""
            ,clinicalHistory:null
            ,clientServices:null
        };

        document.body.classList.add('print-page');
    }

    componentDidMount() {
        Promise.all([
            fetch(API + "getclients&getbyid=" + this.state.clientId)
            ,fetch(API + "getclientclinicalhistory&getbyid=" + this.state.clientId)
            ,fetch(API + "getclientservices&clientid=" + this.state.clientId+"&showolddates=true")
        ])
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((result) => {
            if(result === null || result.shortmsg === "NOK")
                this.props.props.history.push('/Clients');
            else{
                const clientData = result[0].data;

                this.setState({cId:clientData.ClientId != null ? clientData.ClientId : ""
                                ,profilePic:clientData.ProfilePicture != null ? clientData.ProfilePicture : ""
                                ,firstName:clientData.FirstName != null ? clientData.FirstName : ""
                                ,lastName:clientData.LastName != null ? clientData.LastName : ""
                                ,profession:clientData.Profession != null ? clientData.Profession : ""
                                ,fullName:clientData.FullName != null ? clientData.FullName : ""
                                ,gender:clientData.Gender != null ? clientData.Gender : ""
                                ,dateOfBirth:clientData.DateBirth != null ? clientData.DateBirth : ""
                                ,invoiceNumber:clientData.InvoiceNumber != null ? clientData.InvoiceNumber : ""
                                ,idNumber:clientData.IdNumber != null ? clientData.IdNumber : ""
                                ,financeNumber:clientData.FinanceNumber != null ? clientData.FinanceNumber : ""
                                ,iban:clientData.IBAN != null ? clientData.IBAN : ""
                                ,homePhone:clientData.HomePhone != null ? clientData.HomePhone : ""
                                ,cellPhone:clientData.CellPhone != null ? clientData.CellPhone : ""
                                ,homeAddress:clientData.HomeAddress != null ? clientData.HomeAddress : ""
                                ,email:clientData.Email != null ? clientData.Email : ""
                                ,notes:clientData.Notes != null ? clientData.Notes : ""
                                ,isActive:clientData.IsActive != null ? clientData.IsActive : ""
                                ,clinicalHistory: result[1].data
                                ,clientServices: result[2].data});

                setTimeout(function(){
                    window.print();
                },300);
            }
        });
    }

    render() {
        const clientServices = this.state.clientServices!=null ? this.state.clientServices : []
              , clinicalHistory = this.state.clinicalHistory!=null ? this.state.clinicalHistory : []
              , allergies = clinicalHistory.filter(x => x.Type==="1")
              , medications = clinicalHistory.filter(x => x.Type==="2")
              , otherProblems = clinicalHistory.filter(x => x.Type==="3")
              , usedServices = clientServices.filter(x => x.AppointmentId!==null)
              , notUsedServices = clientServices.filter(x => x.AppointmentId===null);

        return (
            <div id="printClientPage" className="addEditPage printContent">
                <div className="fakeHeader"></div>
                <div ref="editForm" className="form">
                    {this.state.clientId!==null ?
                    <div className="coise">
                        <div className="row">
                            <div className="col-12">
                                <h1><i className="fa fa-address-book"></i> {this.state.fullName} <span className="smallText">({this.state.cId})</span></h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-2">
                                <figure className="profilePic">
                                    <img ref="profilePic" src={this.state.profilePic !== "" ? this.state.profilePic : "/img/no_image_available_s.png"} alt={this.state.fullName} title={this.state.fullName} />
                                </figure>
                            </div>
                            <div className="col-12 col-md-10">
                                <div className="row">
                                    <div className="col-md-4">
                                        <p className="label">Primeiro Nome:</p> <p className={"value" + (isNullOrEmpty(this.state.firstName) ? " emptyValue" : "")}> {!isNullOrEmpty(this.state.firstName) ? this.state.firstName : ""}</p>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="label">Último Nome:</p> <p className={"value" + (isNullOrEmpty(this.state.lastName) ? " emptyValue" : "")}> {!isNullOrEmpty(this.state.lastName) ? this.state.lastName : ""}</p>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="label">Profissão:</p> <p className={"value" + (isNullOrEmpty(this.state.profession) ? " emptyValue" : "")}>{!isNullOrEmpty(this.state.profession) ? this.state.profession : ""}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <p className="label">Data Nascimento:</p> <p className={"value" + (isNullOrEmpty(this.state.dateOfBirth) ? " emptyValue" : "")}> {!isNullOrEmpty(this.state.dateOfBirth) ? this.state.dateOfBirth : ""}</p>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="label">Cartão Cidadão:</p> <p className={"value" + (isNullOrEmpty(this.state.idNumber) ? " emptyValue" : "")}> {!isNullOrEmpty(this.state.idNumber) ? this.state.idNumber : ""}</p>
                                    </div>
                                    <div className="col-md-4">
                                        <p className="label">Contribuinte:</p> <p className={"value" + (isNullOrEmpty(this.state.financeNumber) ? " emptyValue" : "")}>{!isNullOrEmpty(this.state.financeNumber) ? this.state.financeNumber : ""}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <p className="label">Telefone:</p> <p className={"value" + (isNullOrEmpty(this.state.homePhone) ? " emptyValue" : "")}>{!isNullOrEmpty(this.state.homePhone) ? this.state.homePhone : ""}</p>
                            </div>
                            <div className="col-md-3">
                                <p className="label">telemóvel:</p> <p className={"value" + (isNullOrEmpty(this.state.cellPhone) ? " emptyValue" : "")}>{!isNullOrEmpty(this.state.cellPhone) ? this.state.cellPhone : ""}</p>
                            </div>
                            <div className="col-md-6">
                                <p className="label">email:</p> <p className={"value" + (isNullOrEmpty(this.state.email) ? " emptyValue" : "")}>{!isNullOrEmpty(this.state.email) ? this.state.email : ""}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-9">
                                <p className="label">Morada:</p> <p className={"value" + (isNullOrEmpty(this.state.homeAddress) ? " emptyValue" : "")}>{!isNullOrEmpty(this.state.homeAddress) ? this.state.homeAddress : ""}</p>
                            </div>
                            <div className="col-md-3">
                                <p className="label">Fatura:</p> <p className={"value" + (isNullOrEmpty(this.state.invoiceNumber) ? " emptyValue" : "")}>{!isNullOrEmpty(this.state.invoiceNumber) ? this.state.invoiceNumber : ""}</p>
                            </div>
                        </div>
                    </div>
                    : ""}
                    <div id="clinicalHistoryHolder" className="row block">
                        <div className="allergiesHolder col-3">
                            <h3>Alergias</h3>
                            { allergies.length >= 1 ?
                                <ul>
                                {allergies.map((history, index) => {
                                    return(<li key={index}>{history.Issue}</li>)
                                })}
                                </ul>
                            : <p>-- Cliente sem alergias. --</p>}
                        </div>
                        <div className="medicationssHolder col-3">
                            <h3>Medicação</h3>
                            { medications.length >= 1 ?
                                <ul>
                                {medications.map((history, index) => {
                                    return(<li key={index}>{history.Issue}</li>)
                                })}
                                </ul>
                            : <p>-- Cliente não toma medicação. --</p>}
                        </div>
                        <div className="otherProblemsHolder col-6">
                            <h3>Outros Problemas</h3>
                            { otherProblems.length >= 1 ?
                                <ul>
                                {otherProblems.map((history, index) => {
                                    return(<li key={index}>{history.Issue} - {history.Description}</li>)
                                })}
                                </ul>
                            : <p>-- Cliente sem outros diagnósticos. --</p>}
                        </div>
                    </div>
                    <div id="clientServicesHolder" className="row block">
                        <div className="usedServices col-7">
                            <h3>Serviços Utilizados</h3>
                            { usedServices.length >= 1 ?
                                <ul>
                                {usedServices.map((service, index) => {
                                    return(<li key={index}>{service.Name} (<strong>{service.DateAppointment + " " + service.HoursAppointment.slice(0, -3)}</strong>)</li>)
                                })}
                                </ul>
                            : <p>Cliente sem serviços utilizados.</p>}
                        </div>
                        <div className="notUsedServices col-5">
                            <h3>Serviços Adquiridos</h3>
                            { notUsedServices.length >= 1 ?
                                <ul>
                                {notUsedServices.map((service, index) => {
                                    return(<li key={index}>{service.Name} <strong>({service.Children})</strong></li>)
                                })}
                                </ul>
                            : <p>Cliente sem serviços adquiridos.</p>}
                        </div>
                    </div>
                </div>
                <div className="fakeFooter"></div>
            </div>
        );
    }
}

export default PrintClient;
